module.exports = __webpack_public_path__ + "img/ppt_forbidden.c7c076e0.svg";